import { Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

export default function PreOrderSuccessPage() {
  return (
    <main className="bg-[#FDFDFD] min-h-screen">
      <SEO title="Pre-Order Confirmed" path="/preorder-success" />
      <div className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 sm:pt-40 pb-16 sm:pb-24 text-center">
        <CheckCircle className="w-12 h-12 mx-auto mb-6 text-[#8B6F47]" strokeWidth={1.5} />
        <h1 className="text-3xl sm:text-4xl tracking-tighter text-[#0A0A0A] mb-4">
          Pre-Order Confirmed
        </h1>
        <p className="text-sm text-[#555] tracking-wide leading-relaxed mb-3 max-w-md mx-auto">
          Thank you for being one of the first to secure pieces from our new collection.
          We've sent a confirmation email with your order details.
        </p>
        <p className="text-sm text-[#888] tracking-wide mb-10 max-w-md mx-auto">
          We'll contact you with payment details and shipping info before we ship. No payment is required now.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/shop"
            className="inline-block bg-[#0A0A0A] text-white px-8 py-3.5 text-xs tracking-[0.2em] uppercase hover:bg-[#1a1a1a] transition-colors"
            style={{ fontStyle: "normal" }}>
            Continue Shopping
          </Link>
          <Link to="/"
            className="inline-block border border-[#E5E5E5] text-[#0A0A0A] px-8 py-3.5 text-xs tracking-[0.2em] uppercase hover:border-[#0A0A0A] transition-colors"
            style={{ fontStyle: "normal" }}>
            Back to Home
          </Link>
        </div>
      </div>
      <Footer />
    </main>
  );
}
